import classNames from 'classnames';
import { Component } from 'react';
import {
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row
} from 'reactstrap';
import { isEmail, isValidPassword } from '../../helpers/regex';
import Button from './Button';
import FormFeedback from './FormFeedback';

export default class Register extends Component{
    constructor(props){
        super(props);
        this.state={
            email:'',
            password:'',
            confirm_password:'',
            _error:null,
            _submit:false
        }
        this._handleChange=this._handleChange.bind(this);
        this._onSubmit=this._onSubmit.bind(this);
    }

    componentWillReceiveProps(nextProps){
    //componentDidUpdate(nextProps){
        if(nextProps.data.isSubmit===false && nextProps.data.isSubmit !== this.props.data.isSubmit && this.state._submit===true){
            if(nextProps.data.error){
                this.setState({_error:{...nextProps.data.error}, _submit:false})
            }
            else
                this.setState({ _submit:false})
        }
    }

    _handleChange(e){
        const lastState={...this.state};
        lastState[e.target.name]=e.target.value;
        this.setState({...lastState});
    }

	_validateForm(){
		const {_error} = this.state;
		let errors={};
        if(this.state.email==='')
            errors['email']=errors['email']!==undefined?[...errors.email,'Harap isi email.']:['Harap isi email.'];
		if(!isEmail(this.state.email))
			errors['email']=errors['email']!==undefined?[...errors.email,'Alamat email tidak valid.']:['Alamat email tidak valid.'];
        if(this.state.password==='')
            errors['password']=errors['password']!==undefined?[...errors.password,'Harap isi password.']:['Harap isi password.'];
        if(!isValidPassword(this.state.password))
            errors['password']=errors['password']!==undefined?[...errors.password,'Password anda harus min 8 karakter termasuk (. ! -) dan gunakan 1 huruf kapital / angka.']:['Password anda harus min 8 karakter termasuk (. ! -) dan gunakan 1 huruf kapital / angka'];
		if(this.state.confirm_password==='')
			errors['confirm_password']=errors['confirm_password']!==undefined?[...errors.confirm_password,'Harap isi confirm password.']:['Harap isi confirm password.'];
		if(this.state.confirm_password!==this.state.password)
			errors['confirm_password']=errors['confirm_password']!==undefined?[...errors.confirm_password,'Confirm password not same with your password.']:['Confirm password not same with your password.'];
        if(Object.keys(errors).length){
            this.setState({
                _error:{errors:{...errors}, status_code:422,message:'Please fulfill your form'}
            })
        }
        return errors;
	}

    _onSubmit(e){
        e.preventDefault();
        this.setState({_error:null});
        if(!Object.keys(this._validateForm()).length){
            this.setState({_submit:true},()=>this.props.onSubmit(this.state))
        }
    }

    _hasError(name){
        if(this.state._error!==null&&this.state._error.status_code===422){
            return Object.keys(this.state._error.errors).filter(err=>err===name).length>0;
        }
        return false;
	}

    render(){
        return(
            <Form className="login-form" onSubmit={this._onSubmit}>
                <FormGroup>
                    <Label>Email</Label>
                    <Input bsSize="md" value={this.state.email} className={classNames("form-control__input--black-lighter",{'is-invalid':this._hasError('email')})} name="email" onChange={this._handleChange} placeholder="Enter your email*"/>
                    <FormFeedback errors={this.state._error!==null?this.state._error.errors:undefined} field="email"/>
                </FormGroup>
                <FormGroup>
                    <Label>Password</Label>
                    <Input bsSize="md" type="password" value={this.state.password} className={classNames("form-control__input--black-lighter",{'is-invalid':this._hasError('password')})} name="password" onChange={this._handleChange} placeholder="Enter your password*"/>
                    <FormFeedback errors={this.state._error!==null?this.state._error.errors:undefined} field="password"/>
                </FormGroup>
                <FormGroup>
                    <Label>Confirm Password</Label>
                    <Input bsSize="md" type="password" value={this.state.confirm_password} className={classNames("form-control__input--black-lighter",{'is-invalid':this._hasError('confirm_password')})} name="confirm_password" onChange={this._handleChange} placeholder="Enter your confirm password*"/>
                    <FormFeedback errors={this.state._error!==null?this.state._error.errors:undefined} field="confirm_password"/>
                </FormGroup>
                <Row>
                    <Col xs={12} md={{size:8,offset:2}} >
                        <Button className="btn-green bold" block size="lg" disabled={this.state._submit} buttonText="REGISTER"/>
                    </Col>
                </Row>
            </Form>
        )
    }
}